import React from "react";
import { ajaxGet, requestPost } from "api/explus-api";
import Main from "../../Main";
import MyUpdates from "./MyUpdates";
import MyUpdatesV2 from "./MyUpdatesV2";

class MyUpdatesContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            community: "",
            projects: [],
            projectId: null,
            communityYears: [],
            loading: false
        };

        this.handleCommunityChangePage = this.handleCommunityChangePage.bind(
            this
        );
    }

    handleChange = e => {
        const value = e.target.value;

        this.getCommunityUpdates(value);

        // this.setState({ projectId: value });
    };

    componentDidUpdate(prevProps) {
        // if (this.props.location !== prevProps.location) {
        //     if (this.props.match.params.year) {
        //         this.getUpdates(
        //             "COMMUNITYBYYEAR",
        //             this.props.match.params.year
        //         );
        //     }
        // }
    }

    componentDidMount() {
        this.initFetch();
        // this.getProjects();
        // if (this.props.match.params.year) {
        //     this.getUpdates("COMMUNITYBYYEAR", this.props.match.params.year);
        // } else {
        //     this.getUpdates("COMMUNITY");
        // }
        // this.getUpdates("COMMUNITYYEARS");
    }

    async initFetch() {
        await ajaxGet("v2/get-community-projects").then(data => {
            this.setState({ projects: data });
        });

        if (this.state.projects.length > 0) {
            await requestPost("v2/get-community-by-project", {
                projectId: this.state.projects[0].id
            })
                .then(data => {
                    if (data.status === "error") {
                        return;
                    }

                    // loader
                    if (this.state.loading === true) {
                        this.setState({ loading: false });
                    }

                    // set state
                    this.setState({ community: data.data });
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }

    getProjects() {
        ajaxGet("v2/get-community-projects").then(data => {
            this.setState({ projects: data });
        });
    }

    getCommunityUpdates = value => {
        this.setState({ loading: true });

        requestPost("v2/get-community-by-project", {
            projectId: value
        })
            .then(data => {
                if (data.status === "error") {
                    return;
                }

                // loader
                if (this.state.loading === true) {
                    this.setState({ loading: false });
                }

                // set state
                this.setState({ community: data.data });
            })
            .catch(err => {
                console.log(err);
            });
    };

    getUpdates(action, prop = "") {
        let url = null;
        let state = null;

        switch (action) {
            case "COMMUNITY":
                url = "web/community";
                state = "community";
                break;
            case "COMMUNITYYEARS":
                url = "web/communityYears";
                state = "communityYears";
                break;
            case "COMMUNITYBYYEAR":
                url = "web/community?year=" + prop;
                state = "community";
                break;
            default:
                return;
        }

        // if (sessionStorage.ge    em(state)) {
        //   items = sessionStorage.getItem(state)

        //   // set cached data if it is available
        //   this.setState({[state]: JSON.parse(items)})
        // } else {

        // loader
        this.setState({ loading: true });

        ajaxGet(url).then(data => {
            if (data.status === "error") {
                return;
            }

            // loader
            if (this.state.loading === true) {
                this.setState({ loading: false });
            }

            // set state
            this.setState({ [state]: data });

            // cache data in sessionStorage
            // sessionStorage.setItem(state, JSON.stringify(data))
        });
        // }
    }

    isLoading() {
        this.setState({ loading: !this.state.loading });
    }

    handleCommunityChangePage(pageNumber) {
        return event => {
            event.preventDefault();

            // loader
            this.isLoading();

            // ajaxGet("web/community", pageNumber).then(data => {
            ajaxGet("v2/get-community-by-project", pageNumber).then(data => {
                if (data.status === "error") {
                    return;
                }

                // loader
                if (this.state.loading === true) {
                    this.setState({ loading: false });
                }

                // set state
                this.setState({ community: data });
            });
        };
    }

    render() {
        return (
            <Main>
                <MyUpdatesV2
                    getCommunityUpdates={this.getCommunityUpdates}
                    projects={this.state.projects}
                    loading={this.state.loading}
                    items={this.state.community}
                    // communityYears={this.state.communityYears}
                    handleCommunityChangePage={this.handleCommunityChangePage}
                    change={this.handleChange}
                />
            </Main>
        );
    }
}

export default MyUpdatesContainer;
